import React from "react";
import "./App.css";
import Home from "./components/home";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      article: {
        loading: true,
        article: []
      }
    };
  }

  render() {
    return (
      <div className="App">
        <Home />
      </div>
    );
  }
}

export default App;
